import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useFocusRing } from "@react-aria/focus";
import { ButtonLegacy } from "./ButtonLegacy.js";
import { useVersionContext, VersionContext } from "./versionContext.js";
import { ButtonStyled, LeftIcon, RightIcon } from "./Button.styles.js";
import { Spinner } from "./Spinner.js";
const ButtonModern = forwardRef(({
  children,
  variant = "secondary",
  isSmall = false,
  icon,
  rightIcon,
  isDisabled = false,
  isLoading = false,
  type = "button",
  isPressed = false,
  isFullWidth = false,
  ...props
}, ref) => {
  const {
    isFocusVisible,
    focusProps
  } = useFocusRing();
  return /* @__PURE__ */ jsx(ButtonStyled, {
    $variant: variant,
    $isSmall: isSmall,
    $isPressed: isPressed,
    $isFullWidth: isFullWidth,
    disabled: isLoading || isDisabled,
    type,
    as: props.href ? "a" : "button",
    $isFocusVisible: isFocusVisible,
    ref,
    ...focusProps,
    ...props,
    children: isLoading ? /* @__PURE__ */ jsxs(Fragment, {
      children: [/* @__PURE__ */ jsx(LeftIcon, {
        "data-testid": "ds-button-loading-icon",
        $lastChild: !children,
        children: /* @__PURE__ */ jsx(Spinner, {})
      }), children]
    }) : /* @__PURE__ */ jsxs(Fragment, {
      children: [icon && /* @__PURE__ */ jsx(LeftIcon, {
        $lastChild: !children,
        children: icon
      }), children, rightIcon && /* @__PURE__ */ jsx(RightIcon, {
        children: rightIcon
      })]
    })
  });
});
const ButtonVersionSwitch = forwardRef((props, ref) => {
  const version = useVersionContext();
  if (version === "legacy") {
    return /* @__PURE__ */ jsx(ButtonLegacy, {
      ref,
      ...props
    });
  }
  return /* @__PURE__ */ jsx(ButtonModern, {
    ref,
    ...props
  });
});
const Button = Object.assign(ButtonVersionSwitch, {
  VersionProvider: VersionContext.Provider
});
export {
  Button
};
//# sourceMappingURL=Button.js.map
